import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ProIcon } from '../components/ProIcon';

const MapPinIcon = () => (
  <svg className="w-12 h-12 text-brand-ocean" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
  </svg>
);

export const NotFound = () => {
  const navigate = useNavigate();

  return (
    <main className="min-h-screen flex items-center justify-center bg-slate-50 pt-24 pb-16 px-4">
      <div className="text-center space-y-8 max-w-md">
        {/* Icon */}
        <div className="w-24 h-24 bg-brand-ocean/10 ui-radius-panel flex items-center justify-center mx-auto">
          <MapPinIcon />
        </div>

        {/* Copy */}
        <div className="space-y-4">
          <h1 className="ui-page-title sm:text-5xl">
            Page Not Found
          </h1>
          <p className="ui-paragraph font-medium sm:text-lg">
            This page doesn't exist — but your perfect Marbella rental does. Let's get you back on track.
          </p>
        </div>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={() => navigate('/')}
            className="ui-btn-primary px-10 py-4"
          >
            Go Home
          </button>
          <button
            onClick={() => navigate('/destinations')}
            className="ui-btn-secondary px-10 py-4 gap-2 group"
          >
            <span>Browse Rentals</span>
            <ProIcon icon="chevron-right" family="light" className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-1" />
          </button>
        </div>
      </div>
    </main>
  );
};
